import { dateFormatters, parseAmericanDate } from '@/utils/date-util'

/**
 * Business information.
 */
export interface BusinessInfo {
  /**
   * The business's name.
   */
  businessName: string

  /**
   * Date of incorporation.
   */
  dateOfIncorporation: Date | null

  /**
   * Employer identification number.
   */
  employerIdentificationNumber: string
}

export const BusinessInfo = {
  /**
   * Empty business info.
   */
  empty: {
    businessName: '',
    dateOfIncorporation: null,
    employerIdentificationNumber: '',
  } satisfies BusinessInfo,
}

/**
 * Formats a date of incorporation for display.
 */
export function formatDateOfIncorporation(date: Date | null): string {
  return date ? dateFormatters.dateAmerican.format(date) : ''
}

/**
 * Parses a date of incorporation string.
 */
export function parseDateOfIncorporation(dateStr: string): Date | null {
  return dateStr ? parseAmericanDate(dateStr) : null
}
